import { useState, useEffect } from 'react';

import { UseOtpResendProps } from './types';

export const useOtpResend = ({ resendFunction, createResendData }: UseOtpResendProps) => {
  const [isResending, setIsResending] = useState(false);
  const [resendMessage, setResendMessage] = useState('');
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  const handleResendOtp = (phoneNumber: string) => {
    setIsResending(true);
    setResendMessage('');

    const resendData = createResendData(phoneNumber);

    resendFunction(resendData)
      .then(() => {
        setIsResending(false);
        setResendMessage('OTP has been resent successfully');
        setCountdown(60);
      })
      .catch(() => {
        setIsResending(false);
        setResendMessage('Failed to resend OTP. Please try again.');
      });
  };

  return {
    isResending,
    resendMessage,
    countdown,
    handleResendOtp,
  };
};
